import type { ReactNode } from "react";
import { cn } from "../../../lib/utils";
import { heroPanel, panel } from "./tokens";

interface PanelProps {
	children: ReactNode;
	className?: string;
	variant?: "default" | "hero";
}

export function Panel({ children, className, variant = "default" }: PanelProps) {
	return <div className={cn(panel, variant === "hero" && heroPanel, className)}>{children}</div>;
}
